// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"Loading_loader_wrapper__E84J5","loader":"Loading_loader__rS1ky","l13":"Loading_l13__QHGQD"};